<template>
  <section class="app-tutorial-wapper">
    <CommonDocumentMain :prefix-path="`/${$route.params.lang}/tutorial`" />
    <div class="mt-6 flex justify-end"><CommonBackToTop /></div>
  </section>
</template>
<script lang="ts" setup>
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-detail-page-cache-tag'])
})
definePageMeta({
  pageTransition: {
    name: '',
    mode: 'out-in'
  }
})

const route = useRoute()
const documentStore = useDocumentStore()
const { fetchDocumentDetail } = documentStore
/* document's p4-id === `${homepage_id}-${tutorial_id} */
if (route.params.id.includes('-')) {
  await fetchDocumentDetail(route.params.id as string, 'tutorial')
} else {
  showError({
    statusCode: 404,
    statusMessage: 'Page Not Found'
  })
}
</script>
<style lang="scss" scoped></style>
